import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { FunctionalRootState, isDisplayAccountHub } from '@share/utils';

import type { AccountSectionId } from './types';
import { getAccountSectionPathById } from './utils';

interface IProps {
  /** The hub section that replaces this page for new My Account tenants. */
  section: AccountSectionId;
  /** The page everyone else keeps (including Capital Vacations). */
  children: React.ReactElement;
}

/**
 * Stand-alone pages that also live inside My Account (e.g. TRAV23-4670's cash out and commissions):
 * hub tenants are sent to the hub section, so there's one place to do it; others keep the page.
 */
export const AccountHubSectionGate = ({ section, children }: IProps): React.ReactElement => {
  const { accountUsername } = useParams<{ accountUsername: string }>();
  const account = useSelector((state: FunctionalRootState) => state.loginStore.account);

  if (isDisplayAccountHub(account)) {
    return <Redirect to={getAccountSectionPathById(encodeURIComponent(accountUsername), section)} />;
  }

  return children;
};
